if (!window.AcademyChessClient) {
    //console.log("AcademyChessClient init starts");
    const AcademyChessClient = {
        iframeElId: "ACClientIframe",
        // cache of last results
        lastResult: {
            inited: false,
        },
        init: function (iframeElId) {
            //console.log(iframeElId, this.iframeElId);
            if (iframeElId !== undefined) {
                this.iframeElId = iframeElId;
            }
            //console.log('AcademyChessClient: Initiating with ', this.iframeElId);
            window.AcademyChessClient.io.init(this.iframeElId);
        },
        sendMessage: function (msg) {
            this.io.sendMessage(msg);
        },
        // addEventListener support for IE8
        bindEvent: function (element, eventName, eventHandler) {
            if (element.addEventListener) {
                element.addEventListener(eventName, eventHandler, false);
            } else if (element.attachEvent) {
                element.attachEvent('on' + eventName, eventHandler);
            }
        },
        auth: function (username, password) {
            this.sendMessage(JSON.stringify({command: 'auth', data: {username, password}}));
        }
    };
    window.AcademyChessClient = AcademyChessClient;

    AcademyChessClient.io = {
        iframeEl: null,
        init(iframeElId) {
            this.iframeEl = document.getElementsByName(iframeElId)[0];
            // Listen to message from child window
            window.AcademyChessClient.bindEvent(window, 'message', function (e) {
                try {
                    // //console.log("AcademyChessClient: received from iframe:", e);
                        //console.log("AcademyChessClient: received from iframe data  :", e.data);

                    const c = JSON.parse(e.data)
                    //console.log('Parsed into', c);
                    switch (c.event) {
                        case "initComplete":
                            //console.log('AcademyChessClient: received valid event ', c)
                            window.AcademyChessClient.lastResult.inited = true;
                            try {
                                window.AcademyChessClient.lastResult.url = c.data.url;
                                //console.log("pageUrl:", c.data.url);
                            } catch (e) {
                                //console.log(e);
                            }
                            return;
                        case "onLoginSuccess":
                        case "onLoginFailure":
                            //console.log('AcademyChessClient: received valid event ', c)
                            //console.log(window.AcademyChessClient.lastResult.auth);
                            window.AcademyChessClient.lastResult.auth = c.event;
                            //console.log(window.AcademyChessClient.lastResult.auth);
                            return;
                        default:
                            //console.log('AcademyChessClient:  AcademyChessClient unknown command')
                    }
                } catch (e) {
//                    //console.log('AcademyChessClient:  parse error', e)
                }
            });
            //console.log('AcademyChessClient:  inited', this.iframeEl)
        },

        // Send a message to the child iframe
        sendMessage: function (msg) {
            // Make sure you are sending a string, and to stringify JSON
            //console.log("AcademyChessClient:  Sending to ", this.iframeEl, " message :", msg)
            if (!this.iframeEl.contentWindow) {
                console.error('no contentWindow')
            } else
                this.iframeEl.contentWindow.postMessage(msg, '*');
        },

    }
    //console.log("AcademyChessClient interface 0.5.0 created")
}

export default window.AcademyChessClient;
